module.exports = __webpack_public_path__ + "img/fontello.7199cf4d.svg";